const namespace = 'components.confirmation_modal.';

const translations = {
    title: `${namespace}title`,
};

export { translations };
